"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResultHeaderTransformer = void 0;
var dateFormatter_1 = require("../../dateFormatting/dateFormatter");
function createResultHeaderTransformer(dateAttributeUris) {
    return function (resultHeader, postProcessing) {
        return dateFormatter_1.transformDateFormat(resultHeader, dateAttributeUris, postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.dateFormat);
    };
}
exports.createResultHeaderTransformer = createResultHeaderTransformer;
//# sourceMappingURL=result.js.map